export default __webpack_public_path__ + "static/media/icon-rundgang.342e4442.svg";